import React from 'react';
import { getObjectProperty } from '@bydesign-ui/utils';
import { ColumnType } from '../../../models/table';
import { TableCellHead } from '../cell/TableCellHead';
import { TableCellData } from '../cell/TableCellData';

function getColumnOrder(sorter, key) {
  var found = sorter.find(function (item) {
    return item.column === key;
  });
  return found ? found.order : 'reset';
}

export function convertColumn(props, sorter, filters, onOrderChange, onFilterChange) {
  var order = getColumnOrder(sorter, props.key);
  var filter = filters[props.key];

  if ('children' in props) {
    return {
      type: ColumnType.GROUP,
      key: props.key,
      show: props.show,
      fixed: props.fixed,
      children: props.children.map(function (item) {
        return convertColumn(item, sorter, filters, onOrderChange, onFilterChange);
      }),
      renderHead: convertRenderHead(props, order, filter, function (nv) {
        return onOrderChange(props.key, nv);
      }, function (nv) {
        return onFilterChange(props.key, nv);
      })
    };
  }

  return {
    type: ColumnType.LEAF,
    key: props.key,
    show: props.show,
    fixed: props.fixed,
    width: props.width,
    widthFixed: props.widthFixed,
    className: props.className,
    renderHead: convertRenderHead(props, order, filter, function (nv) {
      return onOrderChange(props.key, nv);
    }, function (nv) {
      return onFilterChange(props.key, nv);
    }),
    renderData: convertRenderCell(props)
  };
}
export function convertRenderHead(props, order, filter, onOrderChange, onFilterChange) {
  var ellipsis = props.ellipsis,
      title = props.title,
      renderHead = props.renderHead,
      align = props.align,
      _props$sortDirections = props.sortDirections,
      sortDirections = _props$sortDirections === void 0 ? [] : _props$sortDirections,
      _props$filters = props.filters,
      filters = _props$filters === void 0 ? [] : _props$filters,
      filterMultiple = props.filterMultiple;

  var onOrderClick = function onOrderClick() {
    var index = sortDirections.indexOf(order);
    var next = (index + 1) % sortDirections.length;
    onOrderChange(sortDirections[next]);
  };

  if (renderHead != null) {
    return function () {
      return renderHead({
        order: order,
        onOrderClick: onOrderClick,
        sortDirections: sortDirections
      });
    };
  }

  return function () {
    return React.createElement(TableCellHead, {
      sortable: sortDirections.length > 0,
      order: order,
      onOrderClick: onOrderClick,
      ellipsis: ellipsis,
      title: title,
      align: align,
      filterable: filters.length > 0,
      filterValue: filter,
      filterMultiple: filterMultiple,
      filterDataSource: filters,
      onFilterChange: onFilterChange
    });
  };
}
export function convertRenderCell(props) {
  var ellipsis = props.ellipsis,
      dataIndex = props.dataIndex,
      maxLine = props.maxLine,
      valign = props.valign,
      render = props.render,
      align = props.align;
  return function (row, expand, onExpand) {
    var data = render != null ? render(row, expand, onExpand) : dataIndex != null ? String(getObjectProperty(row, dataIndex.split('.'))) : null;
    return React.createElement(TableCellData, {
      ellipsis: ellipsis,
      align: align,
      maxLine: maxLine,
      valign: valign
    }, data);
  };
}